import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

function useHasFocus(ref) {
  var _useState = useState((ref === null || ref === void 0 ? void 0 : ref.current) === document.activeElement),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  useEffect(function () {
    var element = ref.current;

    if (!element) {
      return;
    }

    setState(element === document.activeElement);

    var handleFocus = function handleFocus() {
      return setState(true);
    };

    var handleBlur = function handleBlur() {
      return setState(false);
    };

    element.addEventListener('focus', handleFocus);
    element.addEventListener('blur', handleBlur);
    return function () {
      element.removeEventListener('focus', handleFocus);
      element.removeEventListener('blur', handleBlur);
    };
  }, [ref]);
  return state;
}

export { useHasFocus as default };
